<template>
  <v-overlay
    :value="isLoading"
    z-index="250"
    :opacity="opacity"
  >
    <v-progress-circular
      indeterminate
      :size="spinnerSize"
      :color="spinnerColor"
    />
  </v-overlay>
</template>

<script>
  export default {
    name: "LoadingOverlay",
    props: {
      isLoading: Boolean,
      spinnerColor: {
        type: String,
        default: 'blue lighten-2'
      },
      spinnerSize: {
        type: Number,
        default: 64
      },
      opacity: {
        type: Number,
        default: 0
      }
    }
  }
</script>
